import { SiteSelect } from "components/form/SiteSelect";
import CardCarousel from "components/general/CardCarousel";
import DateSelect from "components/general/DateSelect";
import { Tab, TabContainer } from "components/general/Tabs";
import { Box, Button, HStack, Link, Text, Typography } from "components/ui";
import { Filter, Receipt, Sparkle } from "lucide-react-native";
import React from "react";
import { useGetDashboardSustainabilityQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import ESGImprovementsSection from "./ESGImprovementsSection";
import { useIsPreview } from "utils/hooks/useIsPreview";

const SustainabilitySection = () => {
	const isMobile = useIsMobile();
	const isPreview = useIsPreview();

	const { data } = useGetDashboardSustainabilityQuery({});
	
	if( !isPreview )
	{
		return null;
	}


	if (isMobile) {
		return (
			<Box padding={16}>
				<Box flexDirection="row" mb={16}>
					<Typography.H2 sx={{ marginRight: "auto" }}>Sustainability</Typography.H2>
					<Button py={12} px={12} borderRadius={12} gap={6} backgroundColor="$primarylight" variant="primary">
						<Filter color={"white"} />
					</Button>
				</Box>
				<TabContainer tabTitleSize="tight">
					<Tab bgColor="white" title="Recycling" id={"b"}>
						<Box paddingVertical={16} height={380} justifyContent="center" alignItems="center">
							<Typography.H2>Graphs</Typography.H2>
						</Box>
					</Tab>
					<Tab bgColor="white" title="Contributions" id={"a"}>
						<Box paddingVertical={16}>
							<HStack>
								<Typography.H3>Contributions</Typography.H3>
								<Box ml={"auto"}>
									<Sparkle color={"black"} size={32} />
								</Box>
							</HStack>
							<CardCarousel shownSlideNumber={1}>
								<Box minHeight={300} alignItems="center" justifyContent="center">
									<Typography.H3>Graph</Typography.H3>
								</Box>
								<Box minHeight={300} alignItems="center" justifyContent="center">
									<Typography.H3>Graph</Typography.H3>
								</Box>
								<Box minHeight={300} alignItems="center" justifyContent="center">
									<Typography.H3>Graph</Typography.H3>
								</Box>
							</CardCarousel>
						</Box>
					</Tab>
				</TabContainer>
			</Box>
		);
	}
	return (
		<Box padding={28}>
			<Box flexDirection="row">
				<Typography.H2>Sustainability</Typography.H2>
				{/* <Box ml="auto" flexDirection="row" gap={16}>
					<DateSelect minWidth={250} isLight />
					<SiteSelect minWidth={250} isLight onSelect={() => {}} />
				</Box> */}
			</Box>
			<Box py={28} gap={28} flexDirection="row">
				<Box bg="$basicwhite" borderRadius={12} padding={28} flex={1}>
					<Box justifyContent="center" alignItems="center">
						<Typography.H3>Sustainability Score</Typography.H3>
					</Box>
					<Box minHeight={300} alignItems="center" justifyContent="center">
						<Typography.H3>Graph</Typography.H3>
					</Box>
				</Box>
				<Box bg="$basicwhite" borderRadius={12} padding={28} flex={2}>
					<ESGImprovementsSection 
						data={data || {}}
						ordersCount={207}
						dispatchesCount={54}
					/>
				</Box>
				<Box bg="$basicwhite" borderRadius={12} padding={28} flex={1}>
					<HStack>
						<Typography.H3>Insights</Typography.H3>
						<Box ml={"auto"}>
							<Sparkle size={32} />
						</Box>
					</HStack>
					<CardCarousel shownSlideNumber={1}>
						<Box gap={24} minHeight={300} alignItems="center" justifyContent="center">
							<Typography sx={{ textAlign: "center", fontFamily: "calibri" }}>
								You have 24 products currently in use that can be replaced by alternate Enviroplus equivalents. Doing this will increase the product recycled content to 22%
							</Typography>
							<Box>
								<Link href="#">
									<HStack alignItems="center" gap={6}>
										<Receipt color={"black"} />
										<Text underline>View products</Text>
									</HStack>
								</Link>
							</Box>
						</Box>
						<Box minHeight={300} alignItems="center" justifyContent="center">
							<Typography.H3>Graph</Typography.H3>
						</Box>
						<Box minHeight={300} alignItems="center" justifyContent="center">
							<Typography.H3>Graph</Typography.H3>
						</Box>
					</CardCarousel>
				</Box>
			</Box>
		</Box>
	);
};

export default SustainabilitySection;
